/* MFT Plant Finder. Montana Fruit Trees.
   Filters stack: across groups every pick must match; inside a group any pick can match,
   except "What you want from it", where a plant has to do every use you pick.
   Cold hardiness runs on extremes, same as the Cold Hardiness Calculator: every plant
   carries the coldest temperature it has survived (its lowest Zone tag), and the
   customer types an address (we work out the coldest night to plan for, via
   mft-extreme.js) and we show what has come through that. There is no zone to tap.

   Layout: one row of filter buttons (Quick picks, Cold hardiness, Uses, Deer, and so
   on). Nothing is open until someone taps a button; then just that group opens, as a
   dropdown on a desktop and a bottom sheet on a phone. So the page stays short, and
   the plants sit right under the bar. */
(function () {
  'use strict';

  var USE_KEYS = ['fresh','salad','pie','sauce','cooking','jam','canning','drying','juice','hardcider','wine','spirits','keeper','nuts','vegetable','wildlife','pollinator','ornamental','windbreak','shade','soil','pollenizer','timber'];
  var USE_NAMES = ['Fresh Eating','Salads & Slicing','Pies & Baking','Sauce & Butter','Cooking & Roasting','Jams & Jellies','Canning & Freezing','Drying','Juice & Sweet Cider','Hard Cider','Wine','Brandy & Liqueurs','Good Keeper','Edible Nuts','Perennial Vegetable','Feeds Wildlife','Pollinator Friendly','Ornamental','Windbreak & Hedgerow','Shade Tree','Soil Builder','Good Pollenizer','Valuable Wood'];
  var USE_SHORT = {'Fresh Eating':'Fresh','Salads & Slicing':'Salads','Pies & Baking':'Pies','Sauce & Butter':'Sauce','Cooking & Roasting':'Cooking','Jams & Jellies':'Jam','Canning & Freezing':'Canning','Drying':'Drying','Juice & Sweet Cider':'Juice','Hard Cider':'Hard cider','Perry':'Perry','Wine':'Wine','Brandy & Liqueurs':'Brandy','Good Keeper':'Keeping','Edible Nuts':'Nuts','Perennial Vegetable':'Vegetable','Feeds Wildlife':'Wildlife','Pollinator Friendly':'Pollinators','Ornamental':'Looks','Windbreak & Hedgerow':'Windbreak','Shade Tree':'Shade','Soil Builder':'Soil','Good Pollenizer':'Pollenizer','Valuable Wood':'Wood'};
  var USE_ORDER = ['Fresh Eating','Pies & Baking','Jams & Jellies','Sauce & Butter','Canning & Freezing','Juice & Sweet Cider','Hard Cider','Perry','Wine','Drying','Good Keeper','Cooking & Roasting','Salads & Slicing','Brandy & Liqueurs','Edible Nuts','Perennial Vegetable','Deer Resistant','Feeds Wildlife','Pollinator Friendly','Windbreak & Hedgerow','Ornamental','Good Pollenizer','Shade Tree','Soil Builder','Valuable Wood'];

  // Every half zone, coldest to warmest, the same ladder the calculator uses.
  var ZONES = [];
  for (var zi = 1; zi <= 10; zi++) { ZONES.push(String(zi)); ZONES.push(zi + 'b'); }
  var TRY = 5; // "worth a try" reaches this many degrees past your number, same as the calculator
  var GROUND = [['-5','Cold air settles here','Valley bottom, basin, low spot'],['0','Typical','Open ground. Pick this if unsure'],['3','Slope or bench','Cold air runs downhill past you']];
  var DEER = [
    ['Deer: Rarely Bothered','Rarely bothered','d1'],
    ['Deer: Seldom Badly Damaged','Seldom badly damaged','d2'],
    ['Deer: Sometimes Damaged','Sometimes damaged','d3'],
    ['Deer: Favorite','Deer favorite','d4']
  ];
  var CATS = [
    ['Fruit Tree','Fruit trees'],['Berry','Berries & shrubs'],['Vine','Vines'],['Nut Tree','Nut trees'],
    ['Native','Native plants'],['Perennial Vegetable','Perennial vegetables'],['Hedgerow & Shade','Hedgerow & shade'],['Unusual Fruit','Unusual fruit']
  ];
  var POLL = [
    ['self','Self-fertile, one is enough',['Pollination: Self-Fertile']],
    ['part','Partly self-fertile',['Pollination: Partially Self-Fertile']],
    ['cross','Needs a pollenizer',['Pollination: Needs Cross-Pollination']],
    ['two','Plant two different ones',['Pollination: Heterodichogamous - Plant Two Different Trees','Pollination: Self-Incompatible - Plant Two Genotypes']],
    ['mf','Needs male and female',['Pollination: Dioecious - Needs Male and Female']],
    ['none','No pollination needed',['Pollination: No Pollination Needed']],
    ['wind','Wind-pollinated',['Pollination: Wind-Pollinated']]
  ];
  var BLOOM = ['Very Early','Early','Early-Mid','Mid','Mid-Late','Late','Very Late'];
  var RIPE = [
    ['spring','Spring harvest','before June',0,151],
    ['berry','Berry season','June to Jul 10',152,191],
    ['mid','Midsummer','Jul 11 to 31',192,212],
    ['late','Late summer','Aug 1 to 20',213,232],
    ['end','End of summer','Aug 21 to Sep 10',233,253],
    ['efall','Early fall','Sep 11 to 30',254,273],
    ['mfall','Mid fall','Oct 1 to 15',274,288],
    ['lfall','Late fall','Oct 16 on',289,400]
  ];
  var PRICE = [['p1','Under $50',0,4999],['p2','$50 to $75',5000,7499],['p3','$75 to $100',7500,9999],['p4','$100 and up',10000,1e9]];
  var SORTS = [['match','Best match'],['name','Name, A to Z'],['price','Price, low to high'],['pricehi','Price, high to low'],['ripe','Ripens earliest'],['hardy','Hardiest first']];
  var PRESETS = [
    {label:'Deer resistant', set:{deer:['Deer: Rarely Bothered','Deer: Seldom Badly Damaged']}},
    {label:'Disease resistant', set:{dis:['any']}},
    {label:'One-tree orchard', set:{poll:['self']}},
    {label:'Winter keepers', set:{use:['Good Keeper']}},
    {label:'Pie makers', set:{use:['Pies & Baking']}},
    {label:'Hard cider', set:{use:['Hard Cider']}},
    {label:'Montana natives', set:{cat:['Native']}},
    {label:'Feeds wildlife', set:{use:['Feeds Wildlife']}}
  ];
  // Disease resistance comes from the "Disease Resistant: <disease>" tags, which go on a plant
  // rated 4 or 5 (resistant or highly resistant) on the disease resistance charts.
  var DIS_TAG = 'Disease Resistant: ';
  var DIS_ANY = 'any';
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var MSTART = [1,32,60,91,121,152,182,213,244,274,305,335,366];
  var CARET = '<svg class="mftf-caret" width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 4.5l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var FUNNEL = '<svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"><path d="M3 5h18M6 12h12M10 19h4" stroke="currentColor" stroke-width="2.2" fill="none" stroke-linecap="round"/></svg>';

  function md(d) { d = Math.round(d); var m = 0; while (m < 11 && d >= MSTART[m + 1]) m++; return MON[m] + ' ' + (d - MSTART[m] + 1); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function slug(s) { return String(s).toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function handleize(t) { return String(t).toLowerCase().replace(/&quot;/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function money(c) { var d = c / 100; return '$' + (d % 1 ? d.toFixed(2) : d.toFixed(0)); }
  // Coldest temperature a zone reaches down to: 3 = -40F, 3b = -35F.
  function ztemp(z) { return -60 + (parseInt(z, 10) - 1) * 10 + (/b$/.test(z) ? 5 : 0); }
  // The zone a temperature falls in, on our notation (never an "a").
  function zof(T) { var n = Math.floor((T + 60) / 10) + 1, r = (((T + 60) % 10) + 10) % 10; return n + (r >= 5 ? 'b' : ''); }
  function deg(T) { T = Math.round(T); return (T < 0 ? '−' + (-T) : String(T)) + '°F'; }
  function store(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {} }
  function recall(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }

  // Where you were in the list, kept for this browser tab only (sessionStorage), one entry per
  // page. Back from a plant then lands on that plant with the same number of plants showing,
  // even when the browser had to load the page over again.
  var VIEW = 'mftf_view';
  function views() { try { return JSON.parse(sessionStorage.getItem(VIEW) || '{}') || {}; } catch (e) { return {}; } }
  function viewHere() { var v = views()[location.pathname]; return v && v.qs === location.search ? v : null; }
  // Back, Forward or a reload. Safari can call a Back a plain 'navigate' in the newer timing
  // API, so the older one gets a say too.
  function cameBack() {
    var b = false;
    try { var n = performance.getEntriesByType('navigation')[0]; b = !!n && (n.type === 'back_forward' || n.type === 'reload'); } catch (e) {}
    try { if (performance.navigation && (performance.navigation.type === 1 || performance.navigation.type === 2)) b = true; } catch (e) {}
    return b;
  }
  // The theme scrolls smoothly; a restore should just be there. Smooth scrolling stays off for
  // a moment after, or a slow glide the browser started on its own can carry on and win.
  var smoothT;
  function jumpTo(y) {
    var de = document.documentElement;
    clearTimeout(smoothT);
    de.style.scrollBehavior = 'auto';
    window.scrollTo(0, Math.max(0, y));
    smoothT = setTimeout(function () { de.style.scrollBehavior = ''; }, 1500);
  }
  // Some browsers run their own scroll restore late and undo ours (Firefox can drop you back
  // at the top). For a couple of seconds, until you scroll or tap yourself, keep putting you
  // back. where() works out the spot each time, so it still holds if the page shifts.
  function holdAt(where) {
    var end = Date.now() + 2500, mine = false, evs = ['wheel', 'touchstart', 'keydown', 'pointerdown'];
    function me() { mine = true; }
    function check() {
      if (mine || Date.now() > end) { window.removeEventListener('scroll', check); evs.forEach(function (t) { window.removeEventListener(t, me); }); return; }
      var y = where(); if (y != null && Math.abs((window.pageYOffset || 0) - y) > 60) jumpTo(y);
    }
    evs.forEach(function (t) { window.addEventListener(t, me, {passive: true}); });
    window.addEventListener('scroll', check, {passive: true});
    [300, 900, 1700, 2600].forEach(function (ms) { setTimeout(check, ms); });
  }
  function isPhone() { return window.matchMedia('(max-width: 749px)').matches; }

  function Finder(root) {
    this.root = root;
    this.mode = root.getAttribute('data-mode');
    this.src = root.getAttribute('data-src');
    this.zipUrl = root.getAttribute('data-zips');
    this.deerUrl = root.getAttribute('data-deer');
    this.finderUrl = root.getAttribute('data-finder');
    this.calcUrl = root.getAttribute('data-calc') || '/pages/cold-hardiness-calculator';
    this.calcName = root.getAttribute('data-calcname') || 'MFTC Modified Hardiness Calculator';
    this.usdaNote = root.getAttribute('data-usdanote') || '';
    this.app = root.querySelector('[data-mftf-app]');
    this.items = [];
    this.limit = 36;
    this.state = this.blank();
    this.openKey = null; // which filter group is open, if any
    this.uid = Math.random().toString(36).slice(2, 7);
    this.xr = null; // the last extreme low we worked out, if any
    this.lastH = null; // the plant you opened from this list, on this visit
    this.back = cameBack();
    this.readSaved();
    this.readRipe();
    this.load();
  }

  Finder.prototype.blank = function () {
    return {zone:'', cold:null, tryit:false, use:[], deer:[], dis:[], cat:[], kind:[], ripe:[], poll:[], bloom:[], price:[], stock:false, q:'', sort:'match'};
  };

  // The number we filter cold hardiness against: a looked up extreme low wins over a tapped zone.
  Finder.prototype.limT = function (s) {
    s = s || this.state;
    if (s.cold != null) return s.cold;
    if (s.zone) return ztemp(s.zone);
    return null;
  };

  Finder.prototype.readSaved = function () {
    var raw = recall('mftf_cold'), r = null;
    try { r = raw ? JSON.parse(raw) : null; } catch (e) { r = null; }
    this.saved = r && typeof r.est === 'number' && typeof r.base === 'number' ? r : null;
  };

  Finder.prototype.readRipe = function () {
    var el = this.root.querySelector('[data-mftf-ripe]'), raw = '';
    try { raw = JSON.parse(el.textContent) || ''; } catch (e) {}
    var map = {};
    raw.split('~').forEach(function (l) {
      var a = l.split('|'); if (a.length < 5) return;
      var h = a[5] || handleize(a[4]);
      map[h] = [+a[1], +a[2], a[3] && a[3][0] === '1'];
    });
    this.ripe = map;
  };

  Finder.prototype.load = function () {
    var self = this, base = '/collections/' + String(this.src).replace(/[^\/+]+/g, encodeURIComponent) + '?view=finder-data';
    function get(page) {
      return fetch(base + '&page=' + page, {credentials: 'same-origin'}).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    get(1).then(function (first) {
      var rest = [];
      for (var p = 2; p <= (first.pages || 1); p++) rest.push(get(p));
      return Promise.all(rest).then(function (more) { return [first].concat(more); });
    }).then(function (pages) {
      var rows = [];
      pages.forEach(function (pg) { rows = rows.concat(pg.p || []); });
      self.items = rows.map(function (r, i) { return self.shape(r, i); });
      self.readUrl();
      if (self.state.cold == null && self.mode === 'page' && self.saved) { self.xr = self.saved; self.state.cold = Math.round(self.saved.est); }
      store('mftf_zone', null); // left over from when you could tap a zone
      if (self.saved && self.state.cold != null && Math.round(self.saved.est) === self.state.cold) self.xr = self.saved;
      self.build();
      self.render();
      self.restoreView();
      window.addEventListener('popstate', function () { self.state = self.blank(); self.readUrl(); self.sync(); self.render(); });
    }).catch(function () {
      self.app.innerHTML = self.mode === 'page'
        ? '<p class="mftf-loading">The plant finder did not load. Please refresh, or <a href="/collections/' + esc(self.src) + '">browse every plant</a>.</p>'
        : '';
    });
  };

  Finder.prototype.shape = function (r, i) {
    var tags = r[3] || [], o = {
      h: r[0], t: r[1], ty: r[2], tags: tags, set: {}, pmin: r[4], pmax: r[5], avail: !!r[6], img: r[7],
      sc: {}, chart: r[9], partners: r[10], idx: i
    };
    tags.forEach(function (t) { o.set[t] = 1; });
    (r[8] || []).forEach(function (v, k) { if (v) o.sc[USE_NAMES[k]] = +v; });
    // "Use: Deer Resistant" only feeds the Shop by Use collection; the Deer group covers it here.
    o.uses = tags.filter(function (t) { return t.indexOf('Use: ') === 0 && t !== 'Use: Deer Resistant'; }).map(function (t) { return t.slice(5); });
    var hz = tags.filter(function (t) { return t.indexOf('Hardy Zones ') === 0; })[0];
    o.zones = hz ? hz.slice(12).replace(/–/g, ' to ') : '';
    // Known survival extreme: the coldest zone the plant is tagged into.
    var cold = null;
    tags.forEach(function (t) { var m = /^Zone (\d+b?)$/.exec(t); if (m) { var c = ztemp(m[1]); if (cold === null || c < cold) cold = c; } });
    o.cold = cold;
    o.zmin = cold === null ? 999 : cold;
    var d = DEER.filter(function (x) { return o.set[x[0]]; })[0];
    o.deer = d || null;
    o.dis = tags.filter(function (t) { return t.indexOf(DIS_TAG) === 0; }).map(function (t) { return t.slice(DIS_TAG.length); });
    var bg = tags.filter(function (t) { return t.indexOf('Bloom Group: ') === 0; })[0];
    var bm = bg && /\(([^)]+)\)\s*$/.exec(bg);
    o.bloom = bm ? bm[1] : '';
    o.poll = null;
    POLL.forEach(function (p) { p[2].forEach(function (t) { if (o.set[t]) o.poll = p[0]; }); });
    var rp = this.ripe[o.h] || this.ripe[handleize(o.t)];
    o.rs = rp ? rp[0] : 0; o.re = rp ? rp[1] : 0; o.robs = rp ? rp[2] : false;
    o.ripeKey = '';
    if (rp) { var mid = (rp[0] + rp[1]) / 2; RIPE.forEach(function (w) { if (mid >= w[3] && mid <= w[4]) o.ripeKey = w[0]; }); }
    o.priceKey = '';
    PRICE.forEach(function (p) { if (o.pmin >= p[2] && o.pmin <= p[3]) o.priceKey = p[0]; });
    o.cats = CATS.filter(function (c) { return o.set[c[0]]; }).map(function (c) { return c[0]; });
    o.text = (o.t + ' ' + o.ty).toLowerCase();
    return o;
  };

  /* ---------- state <-> URL ---------- */
  Finder.prototype.readUrl = function () {
    var q = new URLSearchParams(location.search), s = this.state;
    function list(k) { var v = q.get(k); return v ? v.split(',').filter(Boolean) : []; }
    var useSlugs = list('use'), byslug = {};
    USE_ORDER.forEach(function (u) { byslug[slug(u)] = u; });
    s.use = useSlugs.map(function (x) { return byslug[x]; }).filter(Boolean);
    // Zones can't be picked any more; an old link with ?zone=3 becomes that zone's temperature.
    var cold = parseInt(q.get('cold'), 10), oz = q.get('zone') || '';
    s.zone = '';
    s.cold = !isNaN(cold) && cold >= -90 && cold <= 50 ? cold : (ZONES.indexOf(oz) > -1 ? ztemp(oz) : null);
    s.tryit = q.get('try') === '1' && s.cold != null;
    s.deer = list('deer').map(Number).filter(function (n) { return n >= 1 && n <= 4; }).map(function (n) { return DEER[n - 1][0]; });
    var disslug = {}; disslug[DIS_ANY] = DIS_ANY;
    this.items.forEach(function (o) { o.dis.forEach(function (x) { disslug[slug(x)] = x; }); });
    s.dis = list('dis').map(function (x) { return disslug[x]; }).filter(Boolean);
    var catslug = {}; CATS.forEach(function (c) { catslug[slug(c[0])] = c[0]; });
    s.cat = list('type').map(function (x) { return catslug[x]; }).filter(Boolean);
    s.kind = list('kind').map(function (x) { return x.replace(/-/g, ' '); });
    s.ripe = list('ripe'); s.poll = list('poll'); s.price = list('price');
    s.bloom = list('bloom').map(function (x) { return BLOOM.filter(function (b) { return slug(b) === x; })[0]; }).filter(Boolean);
    s.stock = q.get('stock') === '1';
    s.q = q.get('q') || '';
    s.sort = SORTS.some(function (x) { return x[0] === q.get('sort'); }) ? q.get('sort') : 'match';
  };

  Finder.prototype.writeUrl = function () {
    var s = this.state, q = new URLSearchParams(location.search);
    ['zone','cold','try','use','deer','dis','type','kind','ripe','poll','bloom','price','stock','q','sort'].forEach(function (k) { q.delete(k); });
    if (s.cold != null) q.set('cold', String(s.cold));
    else if (s.zone) q.set('zone', s.zone);
    if (s.tryit && this.limT(s) != null) q.set('try', '1');
    if (s.use.length) q.set('use', s.use.map(slug).join(','));
    if (s.deer.length) q.set('deer', s.deer.map(function (d) { return DEER.map(function (x) { return x[0]; }).indexOf(d) + 1; }).join(','));
    if (s.dis.length) q.set('dis', s.dis.map(slug).join(','));
    if (s.cat.length) q.set('type', s.cat.map(slug).join(','));
    if (s.kind.length) q.set('kind', s.kind.map(function (k) { return k.replace(/ /g, '-'); }).join(','));
    if (s.ripe.length) q.set('ripe', s.ripe.join(','));
    if (s.poll.length) q.set('poll', s.poll.join(','));
    if (s.bloom.length) q.set('bloom', s.bloom.map(slug).join(','));
    if (s.price.length) q.set('price', s.price.join(','));
    if (s.stock) q.set('stock', '1');
    if (s.q) q.set('q', s.q);
    if (s.sort !== 'match') q.set('sort', s.sort);
    var qs = q.toString();
    try { history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash); } catch (e) {}
  };

  Finder.prototype.activeCount = function () {
    var s = this.state;
    return (this.limT(s) != null ? 1 : 0) + (s.tryit && this.limT(s) != null ? 1 : 0) + s.use.length + s.deer.length + s.dis.length + s.cat.length + s.kind.length + s.ripe.length + s.poll.length + s.bloom.length + s.price.length + (s.stock ? 1 : 0) + (s.q ? 1 : 0);
  };

  /* ---------- matching ---------- */
  // Parse the typed line once per pass rather than once per plant. The result
  // is cached against the line itself, so scrolling the same query through a
  // few hundred cards costs one parse.
  Finder.prototype.qparse = function (q) {
    if (this._qq === q) return this._qp;
    this._qq = q;
    var B = window.MFTSearch;
    var p = B ? B.parse(q) : null;
    // Only exclusions is a fair thing to type here, since this box filters the
    // list: -crab means show the rest. Empty is the one that falls through.
    if (p && p.empty) p = null;
    this._qp = p;
    return p;
  };

  Finder.prototype.test = function (o, s, skip) {
    if (skip !== 'zone') {
      var T = this.limT(s);
      if (T != null && (o.cold === null || o.cold > T + (s.tryit ? TRY : 0))) return false;
    }
    if (skip !== 'use') for (var i = 0; i < s.use.length; i++) if (o.uses.indexOf(s.use[i]) < 0) return false;
    if (skip !== 'deer' && s.deer.length && !(o.deer && s.deer.indexOf(o.deer[0]) > -1)) return false;
    // Disease works like Uses: a plant has to resist every disease picked.
    if (skip !== 'dis') for (var di = 0; di < s.dis.length; di++) { if (s.dis[di] === DIS_ANY ? !o.dis.length : o.dis.indexOf(s.dis[di]) < 0) return false; }
    if (skip !== 'cat' && s.cat.length && !s.cat.some(function (c) { return o.set[c]; })) return false;
    if (skip !== 'kind' && s.kind.length && s.kind.indexOf(o.ty) < 0) return false;
    if (skip !== 'ripe' && s.ripe.length && s.ripe.indexOf(o.ripeKey) < 0) return false;
    if (skip !== 'poll' && s.poll.length && s.poll.indexOf(o.poll) < 0) return false;
    if (skip !== 'bloom' && s.bloom.length && s.bloom.indexOf(o.bloom) < 0) return false;
    if (skip !== 'price' && s.price.length && s.price.indexOf(o.priceKey) < 0) return false;
    if (skip !== 'stock' && s.stock && !o.avail) return false;
    if (skip !== 'q' && s.q) { var qp = this.qparse(s.q); if (qp) { if (!window.MFTSearch.test(qp, o.text)) return false; } else { var words = s.q.toLowerCase().split(/\s+/).filter(Boolean); for (var w = 0; w < words.length; w++) if (o.text.indexOf(words[w]) < 0) return false; } }
    return true;
  };

  // What the state becomes when a quick pick is tapped: the pick replaces the other
  // filter groups, but your zone (unless the pick is a zone), search, stock and sort stay.
  Finder.prototype.presetState = function (p, from) {
    var st = this.blank();
    st.sort = from.sort; st.q = from.q; st.stock = from.stock;
    if (p.set.zone) { st.zone = p.set.zone; }
    else { st.zone = from.zone; st.cold = from.cold; st.tryit = from.tryit; }
    Object.keys(p.set).forEach(function (k) { if (k !== 'zone') st[k] = p.set[k].slice(); });
    return st;
  };

  Finder.prototype.presetCount = function (p, from) {
    var self = this, st = this.presetState(p, from), n = 0;
    this.items.forEach(function (o) { if (self.test(o, st)) n++; });
    return n;
  };

  Finder.prototype.count = function (row, fn) {
    var self = this, s = this.state, n = 0;
    this.items.forEach(function (o) { if (self.test(o, s, row) && fn(o)) n++; });
    return n;
  };

  /* ---------- building the bar ---------- */
  // Inside the Cold hardiness group: the address lookup, the ground question and the
  // result. There is no zone ladder to tap. The explanation of why our zones run colder than
  // USDA zones is one line that opens out, so the panel stays short.
  Finder.prototype.zoneBody = function (r) {
    var h = '', gname = 'mftf-g-' + this.uid;
    var ex = this.xr ? String(this.xr.ex || 0) : '0';
    h += '<details class="mftf-why"><summary><b>Heads up:</b> our zones run 1 to 3 zones colder than USDA. Why?</summary>';
    h += '<p>' + (this.usdaNote ? esc(this.usdaNote) : 'The USDA map is built on the average coldest night of the year. Ours is built on the extreme one, the night that actually kills trees, so your zone here will usually come out 1 to 3 zones lower (colder) than your USDA zone. That\'s on purpose. Don\'t shop our zone numbers against a USDA based rating.') + ' <a href="' + esc(this.calcUrl) + '">How we figure it</a></p></details>';
    h += '<form class="mftf-xform" data-xform><input type="text" data-addr autocomplete="street-address" placeholder="Street address, or a town and state" aria-label="Where the plants are going" value="' + esc(this.xr && this.xr.addr ? this.xr.addr : '') + '"><button type="submit" data-xgo>Find my extreme low</button></form>';
    h += '<div class="mftf-ground" data-ground role="radiogroup" aria-label="Does cold air settle on your ground?"><span>Does cold air settle on your ground?</span>';
    GROUND.forEach(function (g) {
      h += '<label class="' + (g[0] === ex ? 'is-on' : '') + '" title="' + esc(g[2]) + '"><input type="radio" name="' + gname + '" value="' + g[0] + '"' + (g[0] === ex ? ' checked' : '') + '>' + esc(g[1]) + '</label>';
    });
    h += '</div>';
    h += '<p class="mftf-xmsg" data-xmsg hidden></p>';
    h += '<button type="button" class="mftf-saved" data-saved hidden></button>';
    h += '<div class="mftf-xres" data-xres hidden></div>';
    // No zone ladder to tap: the number comes from the address. Once there is one,
    // this offers the plants that have come within a few degrees of it.
    h += '<div class="mftf-row__vals mftf-tryrow">';
    h += '<button type="button" class="mftf-pill mftf-pill--try" data-try aria-pressed="false" hidden><span>Also show worth a try</span><small>within ' + TRY + '°F</small><em data-c></em></button>';
    h += '</div>';
    return h;
  };

  // A plain group: its pills, with the long lists cut at ten and a "Show all"
  // link, and never a cut that hides just one.
  Finder.prototype.pillBody = function (r) {
    var cut = r.collapse && r.vals.length > r.collapse + 1 ? r.collapse : 0, h = '<div class="mftf-row__vals">';
    r.vals.forEach(function (v, i) {
      h += '<button type="button" class="mftf-pill' + (v.cls ? ' mftf-pill--' + v.cls : '') + (cut && i >= cut ? ' mftf-pill--extra' : '') + '" data-k="' + r.key + '" data-v="' + esc(v.v) + '" aria-pressed="false"><span>' + esc(v.l) + '</span>' + (v.sub ? '<small>' + esc(v.sub) + '</small>' : '') + '<em data-c></em></button>';
    });
    if (cut) h += '<button type="button" class="mftf-showall" data-showall>Show all ' + r.vals.length + '</button>';
    h += '</div>';
    return h;
  };

  // One filter button, and the panel it opens (a dropdown under it, or a sheet up from
  // the bottom on a phone). The button goes in the row and the panel is collected
  // separately: on phones the row scrolls sideways, and iPhone Safari clips anything
  // fixed inside a scrolling box, so the sheet showed up as a sliver inside the row.
  Finder.prototype.group = function (key, chip, heading, hint, body, cls) {
    var id = 'mftf-gp-' + key + '-' + this.uid;
    this.panels += '<div class="mftf-gp mftf-gp--' + key + '" id="' + id + '" data-gp="' + key + '" role="group" aria-label="' + esc(heading) + '" tabindex="-1" hidden>' +
        '<div class="mftf-gp__head"><div><b>' + esc(heading) + '</b>' + (hint ? '<span>' + hint + '</span>' : '') + '</div><button type="button" class="mftf-gp__x" data-gclose aria-label="Close">&times;</button></div>' +
        '<div class="mftf-gp__body">' + body + '</div>' +
        '<div class="mftf-gp__foot">' + (key === 'quick' ? '<span></span>' : '<button type="button" class="mftf-gclear" data-gclear="' + key + '">Clear</button>') + '<button type="button" class="mftf-done" data-gclose>Show plants</button></div>' +
      '</div>';
    return '<div class="mftf-g' + (cls ? ' ' + cls : '') + '" data-g="' + key + '">' +
      '<button type="button" class="mftf-gbtn' + (key === 'quick' ? ' mftf-gbtn--quick' : '') + '" data-gbtn="' + key + '" aria-expanded="false" aria-controls="' + id + '"><span class="mftf-gbtn__l">' + esc(chip) + '</span><span class="mftf-gbtn__v" data-gv hidden></span>' + CARET + '</button>' +
      '</div>';
  };

  Finder.prototype.build = function () {
    var self = this, all = this.items, s = this.state, isPage = this.mode === 'page';
    function present(fn) { return all.some(fn); }
    this.rows = [];

    // Cold hardiness: the address lookup. (The half-zone values stay for reading old ?zone= links.)
    if (present(function (o) { return o.cold !== null; })) {
      this.rows.push({key:'zone', chip:'Cold hardiness', label:this.calcName, hint:'Every plant is rated by the coldest night it has survived, not an average.', single:true, custom:true,
        vals: ZONES.map(function (z) { var t = ztemp(z); return {v:z, l:z, sub:deg(t), f:function (o) { return o.cold !== null && o.cold <= t; }}; })});
    }

    var useVals = USE_ORDER.filter(function (u) { return present(function (o) { return o.uses.indexOf(u) > -1; }); });
    if (useVals.length > 1) this.rows.push({key:'use', chip:'Uses', label:'What you want from it', hint:'Plants must do everything you pick', vals: useVals.map(function (u) { return {v:u, l:u, short:USE_SHORT[u] || u, f:function (o) { return o.uses.indexOf(u) > -1; }}; }), collapse:(isPage ? 14 : 10)});

    var deerVals = DEER.filter(function (d) { return present(function (o) { return o.deer && o.deer[0] === d[0]; }); });
    if (deerVals.length > 1) this.rows.push({key:'deer', chip:'Deer', label:'Deer', hint:'<a href="' + esc(this.deerUrl) + '">How we graded</a>', vals: deerVals.map(function (d) { return {v:d[0], l:d[1], cls:d[2], f:function (o) { return o.deer && o.deer[0] === d[0]; }}; })});

    var disCount = {};
    all.forEach(function (o) { o.dis.forEach(function (x) { disCount[x] = (disCount[x] || 0) + 1; }); });
    var disVals = Object.keys(disCount).sort(function (a, b) { return disCount[b] - disCount[a] || a.localeCompare(b); });
    if (disVals.length) this.rows.push({key:'dis', chip:'Disease', label:'Disease resistance', hint:'Rated resistant on our <a href="/pages/disease-resistance">disease resistance charts</a>. Plants must resist everything you pick.',
      vals: [{v:DIS_ANY, l:'Resists at least one disease', f:function (o) { return o.dis.length > 0; }}].concat(disVals.map(function (x) { return {v:x, l:x, f:function (o) { return o.dis.indexOf(x) > -1; }}; })), collapse:10});

    var catVals = CATS.filter(function (c) { return present(function (o) { return o.set[c[0]]; }); });
    if (catVals.length > 1) this.rows.push({key:'cat', chip:'Plant type', label:'Plant type', vals: catVals.map(function (c) { return {v:c[0], l:c[1], f:function (o) { return o.set[c[0]]; }}; })});

    var kinds = {}; all.forEach(function (o) { if (o.ty) kinds[o.ty] = 1; });
    var kindVals = Object.keys(kinds).sort();
    if (kindVals.length > 1) this.rows.push({key:'kind', chip:'Kind of plant', label:'Kind of plant', vals: kindVals.map(function (k) { return {v:k, l:k.replace(/ (Tree|Shrub|Plant|Vine|Crown|Root)$/,''), f:function (o) { return o.ty === k; }}; }), collapse:14});

    var ripeVals = RIPE.filter(function (w) { return present(function (o) { return o.ripeKey === w[0]; }); });
    if (ripeVals.length > 1) this.rows.push({key:'ripe', chip:'Ripens', label:'Ripens', hint:'Missoula dates. <a href="/pages/ripening-map">See yours</a>', vals: ripeVals.map(function (w) { return {v:w[0], l:w[1], sub:w[2], f:function (o) { return o.ripeKey === w[0]; }}; })});

    var pollVals = POLL.filter(function (p) { return present(function (o) { return o.poll === p[0]; }); });
    if (pollVals.length > 1) this.rows.push({key:'poll', chip:'Pollination', label:'Pollination', hint:'<a href="/pages/pollination-maps">Pollination maps</a>', vals: pollVals.map(function (p) { return {v:p[0], l:p[1], f:function (o) { return o.poll === p[0]; }}; })});

    var bloomVals = BLOOM.filter(function (b) { return present(function (o) { return o.bloom === b; }); });
    if (bloomVals.length > 1) this.rows.push({key:'bloom', chip:'Bloom time', label:'Bloom time', hint:'Later bloom dodges spring frost', vals: bloomVals.map(function (b) { return {v:b, l:b, f:function (o) { return o.bloom === b; }}; })});

    var priceVals = PRICE.filter(function (p) { return present(function (o) { return o.priceKey === p[0]; }); });
    if (priceVals.length > 1) this.rows.push({key:'price', chip:'Price', label:'Price', vals: priceVals.map(function (p) { return {v:p[0], l:p[1], f:function (o) { return o.priceKey === p[0]; }}; })});

    // Quick picks that would show nothing, or everything, in this collection are left out.
    var blank = this.blank(), picks = '';
    PRESETS.forEach(function (p, i) {
      var n = self.presetCount(p, blank);
      if (n > 0 && n < all.length) picks += '<button type="button" data-preset="' + i + '"><span>' + esc(p.label) + '</span><em data-c></em></button>';
    });
    // In stock only, when some are in stock and some aren't (or it is already on from a link).
    var inStock = all.filter(function (o) { return o.avail; }).length;
    var stockBtn = (inStock > 0 && inStock < all.length) || s.stock;

    // A collection page with nothing to filter by (the gift card, say) gets no bar at all.
    this.off = !isPage && !this.rows.length && !picks && !stockBtn;
    if (this.off) { this.app.innerHTML = ''; return; }

    var h = '';
    this.panels = '';
    // The row of filter buttons. Each opens its own panel and nothing else.
    h += '<div class="mftf-groups" data-groups><div class="mftf-gscroll">';
    h += '<span class="mftf-glabel">' + FUNNEL + '<span>Filter</span></span>';
    if (picks) h += this.group('quick', 'Quick picks', 'Quick picks', 'One tap sets a common filter for you', '<div class="mftf-presets">' + picks + '</div>');
    this.rows.forEach(function (r) {
      h += self.group(r.key, r.chip, r.label, r.hint, r.custom ? self.zoneBody(r) : self.pillBody(r));
    });
    if (stockBtn) h += '<button type="button" class="mftf-gbtn mftf-gbtn--toggle" data-stock aria-pressed="false"><span class="mftf-gbtn__l">In stock only</span><em data-c></em></button>';
    h += '</div>';
    // The panels sit beside the row, never inside it (see group() above).
    h += '<div class="mftf-panels">' + this.panels + '</div>';
    h += '</div>';
    this.panels = '';

    // Search, the count and the sort, right over the plants.
    h += '<div class="mftf-bar">';
    h += '<label class="mftf-search"><span class="mftf-sr">Search by name</span><input type="search" data-q placeholder="Search by name" value="' + esc(s.q) + '"><span class="mftf-tip">Try <b>&quot;exact phrase&quot;</b>, <b>-leave out</b>, <b>plum OR cherry</b></span></label>';
    h += '<span class="mftf-count" data-count aria-live="polite"></span>';
    h += '<label class="mftf-sort"><span>Sort</span><select data-sort>' + SORTS.map(function (x) { return '<option value="' + x[0] + '"' + (x[0] === s.sort ? ' selected' : '') + '>' + x[1] + '</option>'; }).join('') + '</select></label>';
    h += '</div>';

    h += '<div class="mftf-chips" data-chips></div>';
    h += '<div class="mftf-results" data-results' + (isPage ? '' : ' hidden') + '><ul class="mftf-grid" data-grid role="list"></ul><div class="mftf-empty" data-empty hidden></div><button type="button" class="mftf-loadmore" data-loadmore hidden></button>';
    if (!isPage) h += '<p class="mftf-bigger">Want to search every plant we grow? <a href="' + esc(this.finderUrl) + '" data-tofinder>Open the full Plant Finder</a></p>';
    h += '</div>';
    h += '<div class="mftf-backdrop" data-backdrop hidden></div>';

    this.app.innerHTML = h;
    this.bind();
    this.sync();
  };

  Finder.prototype.bind = function () {
    var self = this, app = this.app;
    app.addEventListener('click', function (e) {
      var card = e.target.closest ? e.target.closest('a.mftf-card__img, a.mftf-card__title') : null;
      if (card && app.contains(card)) { self.lastH = card.getAttribute('href'); self.keepView(); }
      // Remember which group the click landed in before anything below moves the DOM,
      // so the outside-click check further down can tell a panel click from a page click.
      var inG = e.target.closest ? e.target.closest('[data-g],[data-gp]') : null;
      self._lastG = inG ? (inG.getAttribute('data-g') || inG.getAttribute('data-gp')) : null;
      var b = e.target.closest('button');
      if (!b || !app.contains(b)) return;
      if (b.hasAttribute('data-gbtn')) { var gk = b.getAttribute('data-gbtn'); self.openGroup(self.openKey === gk ? null : gk); }
      else if (b.hasAttribute('data-gclose')) {
        var wasPhone = isPhone();
        self.openGroup(null);
        if (wasPhone) { var r = app.querySelector('[data-results]'); if (r && !r.hidden && self.activeCount()) r.scrollIntoView({behavior:'smooth', block:'start'}); }
      }
      else if (b.hasAttribute('data-gclear')) { self.clearGroup(b.getAttribute('data-gclear')); }
      else if (b.hasAttribute('data-k')) {
        var k = b.getAttribute('data-k'), v = b.getAttribute('data-v'), s = self.state;
        if (k === 'zone') {
          var was = s.cold == null && s.zone === v;
          s.zone = was ? '' : v; s.cold = null;
          if (!s.zone) s.tryit = false;
          if (self.mode === 'page') store('mftf_zone', s.zone || null);
        }
        else { var arr = s[k], i = arr.indexOf(v); if (i > -1) arr.splice(i, 1); else arr.push(v); }
        self.changed();
      } else if (b.hasAttribute('data-try')) { self.state.tryit = !self.state.tryit; self.changed(); }
      else if (b.hasAttribute('data-saved')) { self.useX(self.saved); }
      else if (b.hasAttribute('data-stock')) { self.state.stock = !self.state.stock; self.changed(); }
      else if (b.hasAttribute('data-preset')) {
        self.state = self.presetState(PRESETS[+b.getAttribute('data-preset')], self.state);
        self.changed();
        self.openGroup(null);
      }
      else if (b.hasAttribute('data-clear')) {
        var s0 = self.state, keep = self.mode === 'page';
        self.state = self.blank();
        if (keep) { self.state.zone = s0.zone; self.state.cold = s0.cold; }
        self.app.querySelector('[data-q]').value = '';
        self.changed();
      }
      else if (b.hasAttribute('data-showall')) { b.parentNode.classList.add('is-open'); b.remove(); }
      else if (b.hasAttribute('data-chip')) {
        var ck = b.getAttribute('data-chip'), cv = b.getAttribute('data-cv');
        if (ck === 'zone') { self.state.zone = ''; self.state.cold = null; self.state.tryit = false; }
        else if (ck === 'try') self.state.tryit = false;
        else if (ck === 'stock') self.state.stock = false;
        else if (ck === 'q') { self.state.q = ''; self.app.querySelector('[data-q]').value = ''; }
        else { var ca = self.state[ck], ci = ca.indexOf(cv); if (ci > -1) ca.splice(ci, 1); }
        if (ck === 'zone' && self.mode === 'page') store('mftf_zone', null);
        self.changed();
      }
      else if (b.hasAttribute('data-loadmore')) { self.limit += 36; self.render(); }
      else if (b.hasAttribute('data-share')) { self.share(b); }
    });
    // A click anywhere outside the open dropdown closes it (phones use the backdrop instead).
    document.addEventListener('click', function () {
      var g = self._lastG; self._lastG = null;
      if (self.openKey && g !== self.openKey && !isPhone()) self.openGroup(null);
    });
    app.querySelector('[data-backdrop]').addEventListener('click', function () { self.openGroup(null); });
    var qi = app.querySelector('[data-q]'), t;
    qi.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { self.state.q = qi.value.trim(); self.changed(true); }, 160); });
    app.querySelector('[data-sort]').addEventListener('change', function (e) { self.state.sort = e.target.value; self.changed(); });
    var xf = app.querySelector('[data-xform]');
    if (xf) xf.addEventListener('submit', function (e) {
      e.preventDefault();
      var ai = xf.querySelector('[data-addr]');
      // On a phone, drop the keyboard so the answer isn't hidden behind it.
      if (isPhone()) { try { ai.blur(); } catch (er) {} }
      self.extreme(ai.value);
    });
    var gr = app.querySelector('[data-ground]');
    if (gr) gr.addEventListener('change', function () {
      gr.querySelectorAll('label').forEach(function (l) { l.classList.toggle('is-on', l.querySelector('input').checked); });
      // Same as the calculator: changing your ground moves the number without pulling the weather again.
      if (self.xr && window.MFTExtreme && self.state.cold != null && Math.round(self.xr.est) === self.state.cold) {
        window.MFTExtreme.settle(self.xr, self.groundVal());
        self.remember(self.xr);
        self.state.cold = Math.round(self.xr.est);
        self.changed();
      }
    });
    var tf = app.querySelector('[data-tofinder]');
    if (tf) tf.addEventListener('click', function () { tf.href = self.finderUrl + location.search; });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.openKey) {
        var b = app.querySelector('[data-gbtn="' + self.openKey + '"]');
        self.openGroup(null);
        if (b) b.focus();
      }
    });
    window.addEventListener('pagehide', function () { self.keepView(); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') self.keepView(); });
    // Back to a page the browser kept whole: it's all still here, just point out the plant
    // you came back from.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || !self.lastH) return;
      var c = self.cardFor(self.lastH); self.lastH = null; self.keepView();
      if (c) { var r = c.getBoundingClientRect(); if (r.top < 0 || r.bottom > window.innerHeight) self.toCard(c); self.flash(c); }
    });
    // Crossing between phone and desktop widths with a panel open: close it, the two look nothing alike.
    var mq = window.matchMedia('(max-width: 749px)');
    if (mq.addEventListener) mq.addEventListener('change', function () { self.openGroup(null); });
  };

  // Open one filter group (and close whichever was open), or close them all with null.
  Finder.prototype.openGroup = function (key) {
    var app = this.app, phone = isPhone();
    if (this.openKey && this.openKey !== key) this.setOpen(this.openKey, false);
    this.openKey = key || null;
    if (key) {
      this.setOpen(key, true);
      var p = app.querySelector('[data-gp="' + key + '"]'), b = app.querySelector('[data-gbtn="' + key + '"]');
      if (!phone) {
        // Keep the dropdown inside the row: start under its button, slide left if it would hang off the end.
        var box = app.querySelector('[data-groups]');
        p.style.left = '0px';
        var x = Math.round(b.getBoundingClientRect().left - box.getBoundingClientRect().left);
        p.style.left = Math.max(0, Math.min(x, box.clientWidth - p.offsetWidth)) + 'px';
      } else {
        p.style.left = '';
        p.scrollTop = 0;
      }
      // Move focus into the panel so the keyboard and screen readers land on what just opened.
      try { p.focus({preventScroll: true}); } catch (e) {}
    }
    app.querySelector('[data-backdrop]').hidden = !(key && phone);
    document.documentElement.classList.toggle('mftf-lock', !!(key && phone));
  };

  Finder.prototype.setOpen = function (key, open) {
    var p = this.app.querySelector('[data-gp="' + key + '"]'), b = this.app.querySelector('[data-gbtn="' + key + '"]');
    if (!p || !b) return;
    // Closing with focus inside the panel: hand focus back to its button instead of losing it.
    var had = !open && p.contains(document.activeElement);
    b.parentNode.classList.toggle('is-open', open);
    p.hidden = !open;
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (had) { try { b.focus({preventScroll: true}); } catch (e) {} }
  };

  Finder.prototype.clearGroup = function (k) {
    var s = this.state;
    if (k === 'zone') { s.zone = ''; s.cold = null; s.tryit = false; if (this.mode === 'page') store('mftf_zone', null); }
    else if (k === 'stock') s.stock = false;
    else if (Array.isArray(s[k])) s[k] = [];
    this.changed();
  };

  /* ---------- your spot in the list ---------- */
  Finder.prototype.keepView = function () {
    if (this.off || !this.items.length) return;
    var res = this.app.querySelector('[data-results]');
    if (!res || res.hidden) return;
    var all = views(), keys;
    all[location.pathname] = {qs: location.search, lim: this.limit, y: Math.round(window.pageYOffset || 0), h: this.lastH, t: Date.now()};
    // Only the most recent pages are worth keeping.
    keys = Object.keys(all).sort(function (a, b) { return (all[b].t || 0) - (all[a].t || 0); });
    keys.slice(12).forEach(function (k) { delete all[k]; });
    try { sessionStorage.setItem(VIEW, JSON.stringify(all)); } catch (e) {}
  };

  Finder.prototype.cardFor = function (h) {
    var hit = null;
    if (h) [].some.call(this.app.querySelectorAll('a.mftf-card__title'), function (a) { if (a.getAttribute('href') === h) { hit = a.closest('.mftf-card'); return true; } });
    return hit;
  };

  Finder.prototype.cardY = function (c) { return c.isConnected ? Math.max(0, Math.round(window.pageYOffset + c.getBoundingClientRect().top - window.innerHeight * 0.3)) : null; };
  Finder.prototype.toCard = function (c) { jumpTo(this.cardY(c)); };

  Finder.prototype.flash = function (c) {
    c.classList.add('is-back');
    setTimeout(function () { c.classList.add('is-back-fade'); }, 1800);
    setTimeout(function () { c.classList.remove('is-back', 'is-back-fade'); }, 3600);
  };

  // Came back to the same list: show as many plants as you had open and land on the one you
  // opened (or, with none opened, where you were). The list draws after the page loads, so
  // the browser's own scroll restore lands short or not at all; this finishes the job. A
  // fresh visit starts at the top as usual.
  Finder.prototype.restoreView = function () {
    var v = viewHere(), res = this.app.querySelector('[data-results]');
    if (!v || this.off || !res || res.hidden || !(this.back || v.h)) return;
    var lim = Math.min(+v.lim || 36, 2000);
    if (lim > this.limit) { this.limit = lim; this.render(); }
    var self = this, c = this.cardFor(v.h), y = +v.y || 0;
    if (c) { this.toCard(c); this.flash(c); holdAt(function () { return self.cardY(c); }); }
    else if (this.back) { jumpTo(y); holdAt(function () { return y; }); }
    this.keepView();
  };

  /* ---------- extreme low lookup ---------- */
  Finder.prototype.groundVal = function () {
    var c = this.app.querySelector('[data-ground] input:checked');
    return c ? parseFloat(c.value) || 0 : 0;
  };

  Finder.prototype.remember = function (r) {
    var keep = {est:r.est, base:r.base, ceiling:r.ceiling, avg:r.avg, band:r.band, ex:r.ex, capped:r.capped, zone:r.zone, label:r.label, zip:r.zip, usda:r.usda, why:r.why, elevFt:r.elevFt, addr:r.addr};
    store('mftf_cold', JSON.stringify(keep));
    this.saved = keep;
  };

  Finder.prototype.useX = function (r) {
    if (!r) return;
    this.xr = r;
    var inp = this.app.querySelector('[data-addr]'); if (inp && r.addr) inp.value = r.addr;
    var ex = String(r.ex || 0);
    this.app.querySelectorAll('[data-ground] label').forEach(function (l) { var i = l.querySelector('input'); i.checked = i.value === ex; l.classList.toggle('is-on', i.checked); });
    this.state.cold = Math.round(r.est); this.state.zone = '';
    this.changed();
  };

  Finder.prototype.extreme = function (raw) {
    var self = this, a = String(raw || '').trim(), msg = this.app.querySelector('[data-xmsg]'), go = this.app.querySelector('[data-xgo]');
    function say(t, busy) { msg.hidden = false; msg.innerHTML = (busy ? '<span class="mftf-dot" aria-hidden="true"></span>' : '') + '<span>' + t + '</span>'; }
    if (!a) { say('Type a street address first. A town and state gets you close, but not as close.'); return; }
    if (!window.MFTExtreme) { say('The cold lookup did not load. Refresh the page and try again, or use the <a href="' + esc(this.calcUrl) + '">Cold Hardiness Calculator</a>.'); return; }
    go.disabled = true;
    window.MFTExtreme.lookup(a, this.groundVal(), function (t) { say(esc(t) + '&hellip;', true); }, {zips: this.zipUrl}).then(function (r) {
      r.addr = a;
      msg.hidden = true;
      self.remember(r);
      self.xr = r;
      self.state.cold = Math.round(r.est); self.state.zone = '';
      if (self.mode === 'page') store('mftf_zone', null);
      self.changed();
    }).catch(function (e) {
      say(esc(e && e.message ? e.message : 'Something went wrong. Try again in a moment.'));
    }).then(function () { go.disabled = false; });
  };

  Finder.prototype.showX = function () {
    var box = this.app.querySelector('[data-xres]'), sv = this.app.querySelector('[data-saved]');
    if (!box) return;
    var s = this.state, r = this.xr, live = r && s.cold != null && Math.round(r.est) === s.cold;
    if (sv) {
      var sd = this.saved, offer = sd && !live && !(s.cold != null && Math.round(sd.est) === s.cold);
      sv.hidden = !offer;
      if (offer) sv.innerHTML = 'Use your last spot: <b>' + esc(deg(sd.est)) + '</b>' + (sd.label ? ', ' + esc(sd.label) : '');
    }
    if (!live) { box.hidden = true; box.innerHTML = ''; return; }
    var est = Math.round(r.est), U = r.usda, h = '';
    if (r.label) h += '<p class="mftf-xres__for">For ' + esc(r.label) + (r.elevFt != null ? ' &middot; ' + esc(r.elevFt) + ' ft' : '') + '</p>';
    h += '<div class="mftf-xgrid">';
    h += '<div class="mftf-xbox mftf-xbox--hero"><span>MFTC modified zone (built on extremes)</span><b>' + esc(r.zone) + '</b><small>' + esc(deg(est)) + ' coldest night to plan for &middot; &plusmn;' + Math.round(r.band) + '°F</small></div>';
    if (U) h += '<div class="mftf-xbox mftf-xbox--usda"><span>USDA zone (built on averages)</span><b>Zone ' + esc(U.zone) + '</b><small>' + (U.tr ? esc(U.tr) + '°F average yearly low' : 'Average yearly low') + (r.zip ? ' &middot; ZIP ' + esc(r.zip) : '') + '</small></div>';
    else h += '<div class="mftf-xbox mftf-xbox--usda"><span>Average-based zone</span><b>' + esc(window.MFTExtreme ? window.MFTExtreme.zlab(r.avg) : 'Zone ' + zof(r.avg)) + '</b><small>' + esc(deg(r.avg)) + ' average yearly low at the stations near you</small></div>';
    h += '</div>';
    h += '<p class="mftf-xgap"><b>' + Math.max(0, Math.round(r.avg - r.est)) + '°F colder than the average yearly low</b> near you. The plants below have come through <b>' + esc(deg(est)) + '</b> or colder.</p>';
    if (r.why && r.why.length) h += '<p class="mftf-xconf"><b>Thin weather station coverage here.</b> Take this number with a grain of salt.</p>';
    h += '<details class="mftf-why mftf-why--res"><summary>More about this number</summary><div class="mftf-why__body">';
    h += '<p>The weather stations near you have averaged ' + esc(deg(r.avg)) + ' for their coldest night since 1995. The number above is built on the extreme nights instead, so it comes out ' + Math.max(0, Math.round(r.avg - r.est)) + '°F colder.' + (U && U.zone && zof(est) !== U.zone ? ' That\'s why your MFTC zone (' + esc(zof(est)) + ') comes out lower than your USDA zone (' + esc(U.zone) + ').' : '') + '</p>';
    if (r.why && r.why.length) h += '<p>We don\'t have great weather station coverage for this spot: ' + esc(r.why.join(', and ')) + '. Put more weight on what\'s been growing well around you for years.</p>';
    h += '<p><b>Go by the temperature, not the zone label.</b> Most catalogs zone off averages, so shopping our zone against theirs will leave you under planted. And this is only the cold side of it: early fall freezes, false springs, wind and soil all cause winter loss too. <a href="' + esc(this.calcUrl) + '">See the map, the weather stations and the math</a></p></div></details>';
    box.innerHTML = h;
    box.hidden = false;
  };

  Finder.prototype.changed = function (fromTyping) {
    this.limit = 36;
    this.writeUrl();
    this.sync();
    this.render();
  };

  // What a filter button says once something in it is picked.
  Finder.prototype.groupValue = function (r) {
    var s = this.state;
    if (r.key === 'zone') return s.cold != null ? deg(s.cold) : (s.zone ? 'zone ' + s.zone : '');
    var arr = s[r.key] || [];
    if (!arr.length) return '';
    if (arr.length > 1) return arr.length + ' picked';
    var val = r.vals.filter(function (x) { return x.v === arr[0]; })[0];
    return val ? (val.short || val.l) : arr[0];
  };

  Finder.prototype.sync = function () {
    if (this.off) return;
    var self = this, s = this.state, app = this.app, T = this.limT(s);
    var mine = s.cold != null ? zof(s.cold) : '';
    app.querySelectorAll('[data-k]').forEach(function (b) {
      var k = b.getAttribute('data-k'), v = b.getAttribute('data-v');
      var on = k === 'zone' ? (s.cold == null && s.zone === v) : s[k].indexOf(v) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (k === 'zone') b.classList.toggle('is-yours', v === mine);
      var row = self.rows.filter(function (r) { return r.key === k; })[0];
      var val = row.vals.filter(function (x) { return x.v === v; })[0];
      var n;
      if ((k === 'use' || k === 'dis') && !on) {
        n = 0; self.items.forEach(function (o) { if (self.test(o, s) && val.f(o)) n++; });
      } else n = self.count(k, val.f);
      b.querySelector('[data-c]').textContent = n;
      b.classList.toggle('is-zero', !n && !on);
      b.disabled = !n && !on;
    });
    var tb = app.querySelector('[data-try]');
    if (tb) {
      tb.hidden = T == null;
      tb.setAttribute('aria-pressed', s.tryit && T != null ? 'true' : 'false');
      if (T != null) {
        var tn = this.count('zone', function (o) { return o.cold !== null && o.cold > T && o.cold <= T + TRY; });
        tb.querySelector('[data-c]').textContent = '+' + tn;
        tb.disabled = !tn && !s.tryit;
        tb.classList.toggle('is-zero', !tn && !s.tryit);
      }
    }
    var sb = app.querySelector('[data-stock]');
    if (sb) {
      sb.setAttribute('aria-pressed', s.stock ? 'true' : 'false');
      sb.querySelector('[data-c]').textContent = this.count('stock', function (o) { return o.avail; });
    }
    // Each quick pick shows how many plants it would give you right now, like the pills do.
    app.querySelectorAll('[data-preset]').forEach(function (b) {
      var n = self.presetCount(PRESETS[+b.getAttribute('data-preset')], s);
      b.querySelector('[data-c]').textContent = n;
      b.disabled = !n;
      b.classList.toggle('is-zero', !n);
    });
    // The filter buttons show what is picked inside them.
    this.rows.forEach(function (r) {
      var b = app.querySelector('[data-gbtn="' + r.key + '"]'); if (!b) return;
      var v = self.groupValue(r), gv = b.querySelector('[data-gv]');
      gv.hidden = !v; gv.textContent = v;
      b.classList.toggle('is-active', !!v);
    });
    app.querySelector('[data-sort]').value = s.sort;
    this.showX();
    this.chips();
  };

  Finder.prototype.chips = function () {
    var s = this.state, c = [];
    function chip(k, v, label) { c.push('<button type="button" class="mftf-chip" data-chip="' + k + '" data-cv="' + esc(v) + '">' + esc(label) + ' <span aria-hidden="true">&times;</span><span class="mftf-sr">Remove</span></button>'); }
    if (s.cold != null) chip('zone', '', 'Has come through ' + deg(s.cold));
    else if (s.zone) chip('zone', s.zone, 'Hardy to zone ' + s.zone + ' (' + deg(ztemp(s.zone)) + ')');
    if (s.tryit && this.limT(s) != null) chip('try', '1', 'Plus worth a try');
    s.use.forEach(function (u) { chip('use', u, u); });
    s.deer.forEach(function (d) { chip('deer', d, 'Deer: ' + DEER.filter(function (x) { return x[0] === d; })[0][1].toLowerCase()); });
    s.dis.forEach(function (v) { chip('dis', v, v === DIS_ANY ? 'Disease resistant' : 'Resists ' + v.toLowerCase()); });
    s.cat.forEach(function (v) { chip('cat', v, CATS.filter(function (x) { return x[0] === v; })[0][1]); });
    s.kind.forEach(function (v) { chip('kind', v, v); });
    s.ripe.forEach(function (v) { chip('ripe', v, 'Ripens: ' + RIPE.filter(function (x) { return x[0] === v; })[0][1].toLowerCase()); });
    s.poll.forEach(function (v) { chip('poll', v, POLL.filter(function (x) { return x[0] === v; })[0][1]); });
    s.bloom.forEach(function (v) { chip('bloom', v, 'Blooms ' + v.toLowerCase()); });
    s.price.forEach(function (v) { chip('price', v, PRICE.filter(function (x) { return x[0] === v; })[0][1]); });
    if (s.stock) chip('stock', '1', 'In stock');
    if (s.q) chip('q', s.q, '"' + s.q + '"');
    var el = this.app.querySelector('[data-chips]');
    el.innerHTML = c.length ? c.join('') + '<button type="button" class="mftf-chip mftf-chip--clear" data-clear>Clear all</button><button type="button" class="mftf-chip mftf-chip--share" data-share>Copy link to these results</button>' : '';
  };

  Finder.prototype.share = function (b) {
    var url = location.href;
    function done() { b.textContent = 'Link copied'; setTimeout(function () { b.textContent = 'Copy link to these results'; }, 1800); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () { prompt('Copy this link', url); });
    else prompt('Copy this link', url);
  };

  Finder.prototype.score = function (o) {
    var s = this.state, t = 0;
    s.use.forEach(function (u) { t += o.sc[u] || 5; });
    return t;
  };

  Finder.prototype.render = function () {
    if (this.off) return;
    var self = this, s = this.state, app = this.app, T = this.limT(s);
    var list = this.items.filter(function (o) { return self.test(o, s); });
    var sort = s.sort;
    // Proven plants always come ahead of the worth-a-try ones.
    function proven(a, b) { if (T == null || !s.tryit) return 0; return (a.cold > T ? 1 : 0) - (b.cold > T ? 1 : 0); }
    if (sort === 'match' && s.use.length) list.sort(function (a, b) { return proven(a, b) || (self.score(b) - self.score(a)) || (b.avail - a.avail) || (a.idx - b.idx); });
    else if (sort === 'match') list.sort(function (a, b) { return proven(a, b) || (b.avail - a.avail) || (a.idx - b.idx); });
    else if (sort === 'name') list.sort(function (a, b) { return a.t.localeCompare(b.t); });
    else if (sort === 'price') list.sort(function (a, b) { return a.pmin - b.pmin; });
    else if (sort === 'pricehi') list.sort(function (a, b) { return b.pmin - a.pmin; });
    else if (sort === 'ripe') list.sort(function (a, b) { return (a.rs || 999) - (b.rs || 999); });
    else if (sort === 'hardy') list.sort(function (a, b) { return a.zmin - b.zmin || a.t.localeCompare(b.t); });

    var total = this.items.length, active = this.activeCount() > 0;
    app.querySelector('[data-count]').textContent = active ? list.length + ' of ' + total + ' plants' : total + ' plants';
    app.querySelectorAll('.mftf-done').forEach(function (d) { d.textContent = 'Show ' + list.length + ' plant' + (list.length === 1 ? '' : 's'); });

    var results = app.querySelector('[data-results]');
    if (this.mode === 'collection') {
      // A sort on its own is reason enough to take over from the theme's grid,
      // otherwise picking a sort with no filter would change nothing on screen.
      var showing = active || sort !== 'match';
      results.hidden = !showing;
      this.native(!showing);
    }
    var grid = app.querySelector('[data-grid]'), empty = app.querySelector('[data-empty]'), more = app.querySelector('[data-loadmore]');
    if (!list.length) {
      grid.innerHTML = '';
      empty.hidden = false;
      var msg = '<b>Nothing we grow matches all of that.</b><br>Try removing a filter. Every filter above shows how many plants you would have if you picked it.';
      if (T != null && !s.tryit && this.count('zone', function (o) { return o.cold !== null && o.cold > T && o.cold <= T + TRY; })) msg = '<b>Nothing here has been proven down to ' + esc(deg(T)) + ' yet.</b><br>Some have come close. Open <b>Cold hardiness</b> and tap <b>Also show worth a try</b> to see the ones within ' + TRY + '°F of your number.';
      empty.innerHTML = msg;
      more.hidden = true;
      return;
    }
    empty.hidden = true;
    var shown = list.slice(0, this.limit);
    grid.innerHTML = shown.map(function (o) { return self.card(o); }).join('');
    more.hidden = list.length <= this.limit;
    more.textContent = 'Show ' + Math.min(36, list.length - this.limit) + ' more of ' + (list.length - this.limit);
  };

  Finder.prototype.native = function (show) {
    var sec = this.root.closest('.shopify-section'), n = sec ? sec.nextElementSibling : null;
    // Hide everything between the finder and the native product grid too (the
    // "Browse by type" photo grid), so filtered results sit right under the bar.
    var run = [];
    while (n) {
      run.push(n);
      if (n.querySelector && n.querySelector('results-list, .product-grid-container')) {
        run.forEach(function (el) { el.hidden = !show; });
        break;
      }
      n = n.nextElementSibling;
    }
  };

  Finder.prototype.card = function (o) {
    var s = this.state, facts = [], T = this.limT(s);
    if (o.cold !== null) {
      var tag = '', out = T != null && o.cold > T;
      if (T != null) {
        if (out) tag = ' <span class="mftf-ok mftf-ok--try">worth a try</span>';
        else if (s.cold != null && o.cold > T - TRY) tag = ' <span class="mftf-ok mftf-ok--close">close call</span>';
        else tag = ' <span class="mftf-ok">' + (s.cold != null ? 'hardy here' : 'hardy in ' + esc(s.zone)) + '</span>';
      }
      facts.push('<li class="mftf-f' + (T != null && !out ? ' mftf-f--ok' : '') + '"><b>Cold</b> ' + (out ? 'tested to ' : 'known to ') + esc(deg(o.cold)) + (o.zones ? ' &middot; zones ' + esc(o.zones) : '') + tag + '</li>');
    } else if (o.zones) {
      facts.push('<li class="mftf-f"><b>Zones</b> ' + esc(o.zones) + '</li>');
    }
    if (o.rs) facts.push('<li class="mftf-f"><b>Ripe</b> ' + md(o.rs) + ' to ' + md(o.re) + '</li>');
    if (o.poll) {
      var pl = POLL.filter(function (x) { return x[0] === o.poll; })[0][1];
      var pollTxt = o.poll === 'self' ? 'Self-fertile' : o.poll === 'part' ? 'Partly self-fertile' : pl;
      if ((o.poll === 'cross' || o.poll === 'part') && o.chart) pollTxt += ' &middot; <a href="' + esc(o.chart) + '#' + esc(o.h) + '">' + (o.partners ? o.partners + ' partners' : 'find a partner') + '</a>';
      facts.push('<li class="mftf-f"><b>Fruiting</b> ' + pollTxt + '</li>');
    }
    if (s.dis.length && o.dis.length) facts.push('<li class="mftf-f"><b>Resists</b> ' + esc(o.dis.join(', ')) + '</li>');
    var scores = '';
    if (s.use.length) {
      scores = '<ul class="mftf-scores">' + s.use.map(function (u) {
        var v = o.sc[u];
        if (!v) return '<li><span>' + esc(USE_SHORT[u] || u) + '</span><i><b style="width:0"></b></i><em>yes</em></li>';
        return '<li><span>' + esc(USE_SHORT[u] || u) + '</span><i><b style="width:' + (v * 10) + '%"></b></i><em>' + v + '/10</em></li>';
      }).join('') + '</ul>';
    }
    var price = o.pmin === o.pmax ? money(o.pmin) : 'From ' + money(o.pmin);
    var img = o.img ? '<img src="' + esc(o.img) + '" alt="" loading="lazy" width="480" height="480">' : '';
    var badges = '';
    if (o.deer && (o.deer[2] === 'd1' || o.deer[2] === 'd2')) badges += '<span class="mftf-badge mftf-badge--deer">Deer resistant</span>';
    if (o.set['Native']) badges += '<span class="mftf-badge">Native</span>';
    if (!o.avail) badges += '<span class="mftf-badge mftf-badge--out">Sold out</span>';
    return '<li class="mftf-card' + (o.avail ? '' : ' is-out') + '"><a class="mftf-card__img" href="/products/' + esc(o.h) + '" tabindex="-1" aria-hidden="true">' + img + (badges ? '<span class="mftf-badges">' + badges + '</span>' : '') + '</a>' +
      '<div class="mftf-card__body"><a class="mftf-card__title" href="/products/' + esc(o.h) + '">' + esc(o.t) + '</a><span class="mftf-card__price">' + price + '</span>' +
      scores + (facts.length ? '<ul class="mftf-facts">' + facts.join('') + '</ul>' : '') + '</div></li>';
  };

  function boot() { document.querySelectorAll('[data-mftf]').forEach(function (r) { if (!r.__mftf) { r.__mftf = new Finder(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
